import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
const screenfull = require('screenfull');

import { SettingsService } from '../../core/settings/settings.service';
import { MenuService } from '../../core/menu/menu.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    navCollapsed = true; // for horizontal layout
    menuItems = []; // for horizontal layout
    userId: any;

    isNavSearchVisible: boolean;
    @ViewChild('fsbutton') fsbutton;  // the fullscreen button

    constructor(
        public ngZone: NgZone,
        public menu: MenuService,
        public translateService: TranslateService,
        public settings: SettingsService,
        public router: Router
    ) {
        // show only a few items on demo
        this.menuItems = menu.getMenu().slice(0, 4); // for horizontal layout
    }

    ngOnInit() {
        this.isNavSearchVisible = false;

        var ua = window.navigator.userAgent;
        if (ua.indexOf("MSIE ") > 0 || !!ua.match(/Trident.*rv\:11\./)) { // Not supported under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }

        // Switch fullscreen icon indicator
        const el = this.fsbutton.nativeElement.firstElementChild;
        screenfull.on('change', () => {
            if (el)
                el.className = screenfull.isFullscreen ? 'fa fa-compress' : 'fa fa-expand';
        });

        console.log(Meteor.userId());

        this.userId = Meteor.userId();
    }

    toggleUserBlock(event) {
        event.preventDefault();
        this.settings.toggleLayoutSetting('hideSidebarUserBlock');
    }

    openNavSearch(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setNavSearchVisible(true);
    }

    setNavSearchVisible(stat: boolean) {
        // console.log(stat);
        this.isNavSearchVisible = stat;
    }

    getNavSearchVisible() {
        return this.isNavSearchVisible;
    }

    toggleOffsidebar() {
        this.settings.toggleLayoutSetting('offsidebarOpen');
    }

    toggleCollapsedSideabar() {
        this.settings.toggleLayoutSetting('isCollapsed');
    }

    isCollapsedText() {
        return this.settings.getLayoutSetting('isCollapsedText');
    }

    toggleFullScreen(event) {
        if (screenfull.enabled) {
            screenfull.toggle();
        }
    }

    logout() {
        Meteor.logout((err, res) => {
            if (err) {
                console.warn("Logout error!"); console.warn(err);
            } else {
                // console.warn("Logout OK.");
            }
            this.ngZone.run(() => {
                this.router.navigate(['/login']);
            });
        });
    }

    lockSurface() {
        sessionStorage.setItem('userEmail', Meteor.user().emails[0].address)
        sessionStorage.setItem('userDisplayName', Meteor.user().profile.displayName)

        Meteor.logout()

        this.router.navigate(["/lock"]);
    }
}
